
import { Component } from 'vue-property-decorator';
import AppBar from '@/components/Layout/AppBar.vue';
import Alert from '@/components/Alert.vue';
import store from '@/store';
import { mapActions, mapState } from 'vuex';
import { LayoutState } from '@/store/layout';
import Icon from '@/components/Icons/Icon.vue';
import { SupportModalMixin } from '@/mixins/SupportModalMixin';
import SupportModal from '@/components/Modals/Support/SupportModal.vue';

@Component({
  components: {
    SupportModal,
    Icon,
    AppBar,
    Alert,
  },
  computed: {
    ...mapState<LayoutState>('layout', {
      drawer: (state: LayoutState) => state.drawer,
      isNavigationMobile: (state: LayoutState) => state.isNavigationMobile,
      supportModalShow: (state: LayoutState) => state.supportModalShow,
      globalOverlay: (state: LayoutState) => state.globalOverlay,
    }),
  },
  methods: {
    ...mapActions('layout', ['setDrawerState', 'setNavigationMobileState']),
  },
})
export default class Mainframe extends SupportModalMixin {
  drawer!: boolean;
  isNavigationMobile!: boolean;
  setNavigationMobileState!: (isMobile: boolean) => any;

  windowSize: { width: number; height: number } = {
    width: 0,
    height: 0,
  };

  async refreshApplication(): Promise<void> {
    await store.dispatch('layout/setRefreshNotice', false);
    window.location.reload();
  }

  onResizeNavigation(): void {
    this.onResize();
    this.setNavigationMobileState(this.windowSize.width < 1264);
  }

  created(): void {
    // Check if modal is present in query and show it based on trigger
    if (this.$route.query.modal === 'support') {
      this.toggleSupportModal(true);
    }
  }

  onResize(isLogOn = false): void {
    this.windowSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    };

    if (isLogOn) {
      console.log('Width = ', this.windowSize.width);
      console.log('Height = ', this.windowSize.height);
    }
  }
}
